// @flow

import { clear as clearLocalStorage } from '@rover/react-lib/apis/localStorage.api';
import { clear as clearSessionStorage } from '@rover/react-lib/apis/sessionStorage.api';

export type LogoutConfig = {
  nextLocation: string,
  ref?: string,
  beforeNavCallback?: () => void,
};

export default async function({ nextLocation, ref, beforeNavCallback }: LogoutConfig) {
  clearLocalStorage();
  clearSessionStorage();
  beforeNavCallback && beforeNavCallback();
  const encodedLocation = encodeURIComponent(nextLocation);
  // eslint-disable-next-line rover/no-platform-specific-globals-or-imports
  window.location.href = `/logout/?next=${encodedLocation}${ref ? `&${ref}` : ''}`; // This is the actual logout
}



// WEBPACK FOOTER //
// ../react-lib/src/apis/logout.api.js